import Decimal from 'decimal.js';

export enum CURRENCY {
  USD = 'USD',
  LBP = 'LBP',
  EUR = 'EUR',
}

enum CURRENCY_FACTOR {
  USD = 90000,
  LBP = 1,
  EUR = 1.13 * 90000,
}

const get_currency_factor = (curr: CURRENCY) => {
  if (curr == CURRENCY.USD) return CURRENCY_FACTOR.USD;
  if (curr == CURRENCY.LBP) return CURRENCY_FACTOR.LBP;
  if (curr == CURRENCY.EUR) return CURRENCY_FACTOR.EUR;
  throw new Error('invalid currency');
};

export const Currencies = Object.values(CURRENCY);

export type Money = [CURRENCY, Decimal];
export type OptionalMoney = [CURRENCY, Decimal | null];

export const moneyToMetric = (m: Money[]) => {
  let metric = Decimal(0);
  console.log(m);
  m.forEach((item) => {
    console.log(item);
    metric = metric.add(Decimal(item[1]).mul(get_currency_factor(item[0])));
  });
  return metric;
};

export function reduce(money: Money[]): Map<CURRENCY, Decimal> {
  const res = new Map<CURRENCY, Decimal>();
  money.forEach((m) => res.set(m[0], (res.get(m[0]) ?? Decimal(0)).plus(m[1])));
  return res;
}

export function add(m1: Money[], m2: Money[]): Money[] {
  const r1 = reduce(m1);
  const r2 = reduce(m2);
  r2.forEach((amount, currency) =>
    r1.set(currency, (r1.get(currency) ?? Decimal(0)).add(amount))
  );
  const res: Money[] = [];
  r1.forEach((val, key) => {
    if (!val.isZero()) res.push([key, val]);
  });
  return res;
}

export function minus(m1: Money[], m2: Money[]): Money[] {
  const r1 = reduce(m1);
  const r2 = reduce(m2);
  r2.forEach((amount, currency) =>
    r1.set(currency, (r1.get(currency) ?? Decimal(0)).minus(amount))
  );
  const res: Money[] = [];
  r1.forEach((val, key) => {
    if (!val.isZero()) res.push([key, val]);
  });
  return res;
}

export function get_symbol(currency: CURRENCY): string {
  switch (currency) {
    case CURRENCY.USD:
      return '$';
    case CURRENCY.LBP:
      return 'LL';
    case CURRENCY.EUR:
      return '€';
  }
}

export function get_precision(currency: CURRENCY): number {
  switch (currency) {
    case CURRENCY.USD:
      return 2;
    case CURRENCY.LBP:
      return 0;
    case CURRENCY.EUR:
      return 2;
  }
}

export function displayMoney(money: Money[], showSigns = false) {
  console.log("money = ", money)
  if (!money) return 'ERROR';
  let val = '';
  try {
    money.forEach((item, index) => {
      if (!Decimal(item[1]).isZero())
        val += `${index > 0 ? ', ' : ''}${showSigns ? (Decimal(item[1]).isPositive() ? '+' : '-') : ''}${item[1]} ${get_symbol(item[0])}`;
    });
    return val.length == 0 ? '0' : val;
  } catch(e) {
    console.log(e)
    return 'ERROR';
  }
}

export function isNonZero(money: Money[]): boolean {
  let hasMoney = false;
  money.forEach((item, index) => {
    if (!Decimal(item[1]).isZero()) hasMoney = true;
  });
  return hasMoney;
}
